import Vue3PersianDatetimePicker from 'vue3-persian-datetime-picker'
export default defineNuxtPlugin((app) => {
    app.vueApp.component('persianDatePicker', Vue3PersianDatetimePicker);
});